import { CognitoUserPool } from 'amazon-cognito-identity-js';
import Config from './Config';

const poolData = {
  UserPoolId: Config.USERPOORID,
  ClientId: Config.CLIENTID,
};

export default new CognitoUserPool(poolData);
